import { Link } from "react-router-dom";

export default function PrephysicianCardSmall (props){


let h5Style = {
    fontSize: '18px',
    fontWeight: '700',
    textAlign: 'center',
    margin: '0'
  }

let pStyle = {
  fontSize: '16px',
  fontWeight: '500',
  textAlign: 'left',
  margin: '3px 0 0 0'
}


return (
  <>
      <Link
       onClick={()=>props.setPrephysicianModal(props.prephysician_id)}
       to={"/prephysiciandetails"}
       style={{textDecoration: 'none', color: "inherit"}}
      >
        <div
            className='hoverCard'
            key={props.prephysician_id}
            style={{
              background: '#FFF',
              border: 'none',
              borderRadius: '10px',
              width: '300px',
              padding: '10px',
              margin: '20px 10px 10px 0px',
              // boxShadow: '0 4px 8px 0 rgba(0, 0, 0, .2), 0 3px 10px 0 rgba(0, 0, 0, .15)',
              cursor: 'pointer',
            }}
          >
          <h5 style = {h5Style}>
            {props.formal_name}
          </h5>
          <hr style = {{borderTop: '1px solid #8c8b8b'}}/>
          <div style = {{padding: '5px 5px 15px 10px'}}>
            <p style = {pStyle}>
              <strong>Education:</strong> {props.institution}
            </p>
            <p style = {pStyle}>
              <strong>Location:</strong> {props.state_name}
            </p>
            <p style = {pStyle}>
              <strong>Skills:</strong> {props.skills}
            </p> 
          </div>
        </div>
      </Link>
  </>
)
}